import _ActivityTracker from './ActivityTracker';

const ActivityTracker = _ActivityTracker;

export default ActivityTracker;
